export default __webpack_public_path__ + "static/media/photos_3.cd3f3997.jpg";